module.exports = __webpack_public_path__ + "img/8.4a84eec.jpg";